// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e30cd0b1","453":"0caa3c72","455":"da378e97","977":"b04c7e16"}[chunkId] + ".chunk.js";
};